import { PaymentsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { PAYMENTS_API_URL } = process.env;

export default new PaymentsApi(PAYMENTS_API_URL, {}, olyEngineApi);
